import { Divider } from "@mui/material";
import useConditionalOpen from "../useConditionalOpen";
import FormSectionHeader from "../FormSectionHeader";
import { JobAdIntegrationType, SectionProps } from "../../types/common";

type DuunitoriSectionProps = SectionProps;

const DuunitoriSection = ({
  isEditing,
  onPublishSelection,
  integrationsToPublish,
  selectedJobAd,
}: DuunitoriSectionProps) => {
  const integrationType = JobAdIntegrationType.Duunitori;
  const integrationIsSelectedToBePublished =
    integrationsToPublish?.includes(integrationType);

  const [open, handleToggle] = useConditionalOpen(
    true,
    integrationIsSelectedToBePublished,
  );

  return (
    <>
      {(isEditing || integrationIsSelectedToBePublished) && (
        <>
          <FormSectionHeader
            isOpen={open}
            toggleOpen={handleToggle}
            title={"DUUNITORI"}
            integrationType={integrationType}
            onPublishSelection={onPublishSelection}
            isEditing={isEditing}
            selectedJobAd={selectedJobAd}
            integrationIsSelectedToBePublished={
              integrationIsSelectedToBePublished
            }
          />
          <Divider
            sx={{
              margin: "24px 0 16px 0",
            }}
          />
        </>
      )}
    </>
  );
};

export default DuunitoriSection;
